import type { PopTone } from "../types";

export const TONE_BG: Record<PopTone, string> = {
  orange: "bg-pop-orange text-white",
  yellow: "bg-pop-yellow text-ink",
  pink: "bg-pop-pink text-white",
  purple: "bg-pop-purple text-white",
  teal: "bg-pop-teal text-ink",
  green: "bg-pop-green text-white",
  white: "bg-white text-ink",
  ink: "bg-ink text-white",
};

const IMG = (h: string) => `/img/${h.slice(0, 12)}.webp`;
export const MASCOT_BULB = IMG("b18fa5079726b4e0dd689898db91d0b4d11909fe7b62fefb934c248db09a136f");
export const COIN_HERO = IMG("5dc748b6dddb305b8ed03166418a750ef9b79ac2c89012842ddf3e67a5415ddf");
export const DICE_HERO = IMG("59ac06f4537a628e072fc263bc3679bfcc654b9a1735f91275b549fe882d124e");
export const MASCOT_THINK = IMG("9ca9278ea206");
export const MASCOT_CHEER = IMG("36d6edbd21e8");
